import Menu from "../../components/Menu/Menu"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { useTranslation } from "react-i18next"
import {
  faDatabase,
  faLock,
  faUserShield,
  faServer,
  faEnvelope,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SEO } from "../../seo/Seo"
import { ContractDownloadsCard } from "../../components/ContractDownloads/ContractDownloadsCard"

export default function PrivacyPolicy() {
  const { t } = useTranslation("privacy")

  const sections = [
    {
      icon: faDatabase,
      title: t("privacy1_title"),
      content: [t("privacy1_description")],
    },
    {
      icon: faUserShield,
      title: t("privacy2_title"),
      content: [t("privacy2_description")],
    },
    {
      icon: faServer,
      title: t("privacy3_title"),
      content: [t("privacy3_description")],
    },
    {
      icon: faLock,
      title: t("privacy4_title"),
      content: [t("privacy4_description")],
    },
    {
      icon: faEnvelope,
      title: t("privacy5_title"),
      content: [t("privacy5_description")],
    },
    {
      icon: faFileContract,
      title: t("privacy6_title"),
      content: [t("privacy6_description")],
    },
  ]

  return (
    <Animate type={AnimationTypes.fadeIn}>
      <div className="min-h-screen bg-white">
        <SEO
          title="Política de privacidade para sistema de restaurante Mestre da Comanda"
          description="Conheça a política de privacidade do Mestre da Comanda para uso do sistema de pedidos online e gestão para restaurante."
          path="/privacy-policy"
        />

        <Menu />

        <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="space-y-8 mt-20">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white border-l-4 border-red-500 shadow-md rounded-lg p-6 transition hover:shadow-lg"
              >
                <div className="flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-orange-400 flex items-center justify-center text-white shadow-md">
                    <FontAwesomeIcon icon={section.icon} />
                  </div>

                  <div className="flex-1">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3">{section.title}</h2>

                    <div className="space-y-3">
                      {section.content.map((text, i) => (
                        <p key={i} className="text-sm sm:text-base text-gray-600 leading-relaxed">
                          {text}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <ContractDownloadsCard showAutomaticAcceptance />
          </div>
        </main>
      </div>
    </Animate>
  )
}
